export default __webpack_public_path__ + "static/AC_Parallax_Forward-71bb95d5285bbdb6a690388ec9c742a5.jpg";